import { Box, CursorType, Icon, Tag } from '@dtx-company/shared-components/src'
import { lockIconBlackBackground } from '../../constants/assets'
import { lockIconWhite } from '../../assets'
import React from 'react'

interface ProTagProps {
  minimalIcon?: boolean
  onClick?: () => void
  isProPlus?: boolean
  cursor?: CursorType
  iconWidth?: string
  tagCopy?: string
}

export const ProTag: React.FC<ProTagProps> = ({
  minimalIcon,
  onClick,
  isProPlus = false,
  cursor = 'auto',
  iconWidth = '100%',
  tagCopy
}) => {
  const cursorType = onClick ? 'pointer' : cursor
  const defaultCopy = isProPlus ? 'PRO PLUS' : 'PRO'
  const copy = tagCopy ?? defaultCopy

  return minimalIcon ? (
    <Box
      data-testid={'pro-feature-tag-icon'}
      onClick={onClick}
      justifyContent="center"
      width={iconWidth}
      cursor={cursorType}
      my={'auto'}
      ml={'4px'}
    >
      <Icon src={lockIconBlackBackground} alt="lock icon" width="50px" />
    </Box>
  ) : (
    <Tag
      data-testid={'pro-feature-tag-text'}
      onClick={onClick}
      icon={lockIconWhite}
      cursor={cursorType}
      ml="8px"
      height="fit-content"
      minWidth="max-content"
      backgroundColor="primary.black"
      color="primary.white"
      label={copy}
      bold
    />
  )
}
